import { WidgetNames } from "../constants/WidgetNames";

export const getInitialDisplayName = (widget, selectedFieldDriverName) => {
    if (widget.dataProps && widget.dataProps.displayName) {
        return widget.dataProps.displayName;
    }

    switch (widget.text) {
        case WidgetNames.AVERAGE_SCORE:
            return `Average ${selectedFieldDriverName}`;
        // case WidgetNames.NUMBER_METADATA_BREAKDOWN:
        //     return selectedFieldDriverName;
        default:
            return widget.text;
    }
};
